import styled from 'styled-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';

export const ExtraInfoDiv = styled.div`
  font-size: 15px;
  text-align: justify;
  margin-top: 15px;
  color: #737482;
`;

export const RequirementDiv = styled.div`
  padding-bottom: 15px;
  display: flex;
  align-items: center;
`;

export const RequirementTitleDiv = styled.div`
  color: #000000;
  padding-bottom: 15px;
  font-size: 17px;
`;

export const Paragraph = styled.span`
  display: '';
  padding-right: 5px;
`;

export const MainContainer = styled(Flex).attrs({ flexDirection: 'column' })`
  background-color: ${toColorString(color.base.halfMoon)};
  margin: -15px -15px 60px -20px;
  min-height: calc(100vh - 130px);
  padding: 50px 0 20px;
`;

export const FormsContainer = styled(Flex).attrs({
  flexDirection: 'column',
  alignItems: 'center',
})`
  width: 560px;
  background-color: ${toColorString(color.base.snowWhite)};
  padding: 40px 100px 40px;
`;

export const ButtonsContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
  row-gap: 5px;
  align-items: start;

  @media screen and (max-width: 390px) {
    flex-direction: column-reverse;

    .btn__element--login-btn {
      margin-bottom: 15px;
    }
  }
`;

export const PasswordResetContainer = styled(Flex)`
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 560px;
  flex-direction: column;
  padding: 60px 40px 40px;
  row-gap: 5px;
  background-color: ${toColorString(color.base.snowWhite)};

  @media screen and (max-width: 560px) {
    width: 350px;
  }
`;

export const StyledAlert = styled.div`
  margin-bottom: 5px;

  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
